// contexts/NotificationContext.jsx
import React, { createContext, useState, useCallback } from 'react';

// 創建通知上下文
const NotificationContext = createContext();

// 唯一 ID 生成器
let nextId = 1;

export const NotificationProvider = ({ children }) => {
    const [notifications, setNotifications] = useState([]);

    // 顯示通知
    const showNotification = useCallback((message, type = 'info', duration = 3000) => {
        const id = nextId++;
        const notification = { id, message, type, duration };

        setNotifications(prev => [...prev, notification]);

        // 設定自動消失的計時器
        if (duration > 0) {
            setTimeout(() => {
                hideNotification(id);
            }, duration);
        }

        return id;
    }, []);

    // 隱藏特定通知
    const hideNotification = useCallback((id) => {
        setNotifications(prev => prev.filter(notification => notification.id !== id));
    }, []);

    // 隱藏所有通知
    const clearAllNotifications = useCallback(() => {
        setNotifications([]);
    }, []);

    // 便捷方法：顯示成功通知
    const showSuccess = useCallback((message, duration = 3000) => {
        return showNotification(message, 'success', duration);
    }, [showNotification]);

    // 便捷方法：顯示錯誤通知
    const showError = useCallback((message, duration = 5000) => {
        return showNotification(message, 'error', duration);
    }, [showNotification]);

    // 便捷方法：顯示警告通知
    const showWarning = useCallback((message, duration = 4000) => {
        return showNotification(message, 'warning', duration);
    }, [showNotification]);

    // 便捷方法：顯示信息通知
    const showInfo = useCallback((message, duration = 3000) => {
        return showNotification(message, 'info', duration);
    }, [showNotification]);

    return (
        <NotificationContext.Provider
            value={{
                notifications,
                showNotification,
                hideNotification,
                clearAllNotifications,
                showSuccess,
                showError,
                showWarning,
                showInfo
            }}
        >
            {children}
        </NotificationContext.Provider>
    );
};

export default NotificationContext;